import { Controller } from "@hotwired/stimulus"

// Show/hide toggle for one slide's on-slide feedback pins (deck #28 incident
// follow-up, third round) -- a quick way to see everything annotated on the
// slide at a glance, or hide them all to see the artwork clean. Purely a
// client-side view preference, scoped to THIS slide: no server round-trip,
// no persistence (Sky's explicit ask) -- default state is pins visible,
// matching current behaviour before this button existed.
//
// Lives on the toolbar button ALONE (decks/_slide_toolbar.html.erb), rather
// than sharing a Stimulus scope with the pins container it toggles
// (decks/_slide_feedback_pins.html.erb, rendered inside the slide canvas
// below). Those two only share a common ancestor in
// decks/_viewer_chrome.html.erb -- a DIFFERENT card's untouched in-progress
// work (card #2233) -- so this addresses its target by a computed element id
// instead of a Stimulus target, matching decks/_slide_feedback_pins.html.erb's
// own turbo_stream target id exactly.
//
// ACCEPTED TRADE-OFF: a turbo_stream.replace of the pins container (posting
// a new comment, or resolving one) always re-renders it visible -- there is
// no client state threaded through that replace, so toggling pins off and
// then posting/resolving one un-hides them again. Sky's ask was explicitly
// "no persistence needed"; this is that same simplicity applied consistently.
export default class extends Controller {
  static values = { pinsId: String }

  connect() {
    this.visible = true
  }

  toggle(event) {
    event.preventDefault()

    const pins = document.getElementById(this.pinsIdValue)
    if (!pins) return

    this.visible = !this.visible
    pins.classList.toggle("hidden", !this.visible)
    this._updateButtonState(event.currentTarget)
  }

  _updateButtonState(button) {
    button.classList.toggle("bg-gray-100", this.visible)
    button.classList.toggle("text-sapphire", this.visible)
    button.classList.toggle("text-gray-400", !this.visible)
    button.setAttribute("aria-pressed", String(this.visible))
    button.title = this.visible ? "Hide feedback pins" : "Show feedback pins"
  }
}
